import { render, staticRenderFns } from "./hotList.vue?vue&type=template&id=e720c294&scoped=true"
import script from "./hotList.vue?vue&type=script&lang=js"
export * from "./hotList.vue?vue&type=script&lang=js"
import style0 from "./hotList.vue?vue&type=style&index=0&id=e720c294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e720c294",
  null
  
)

export default component.exports